import React from 'react';
import PropTypes from 'prop-types';
import { StepItem } from './';

const carouselClasses = `onboarding-steps-list carousel-indicators`;

const StepsList = ({ steps, currentStep }) =>
  <ul className={carouselClasses}>
    {steps.map((step, index) =>
      <StepItem
        key={index}
        numStep={index + 1}
        data={step}
        slideActive={index + 1 === currentStep}
      />
    )}
  </ul>;

StepsList.propTypes = {
  steps: PropTypes.arrayOf(PropTypes.string).isRequired,
  currentStep: PropTypes.number.isRequired
};

export default StepsList;



// WEBPACK FOOTER //
// ./src/components/OnboardingFlow/components/StepsList.js